import React from "react";

var ContainerSearch = function ContainerSearch(props) {
  var checkParams = function checkParams() {
    return props.search && (props.searchParam || props.searchParams) && props.template && Array.isArray(props.options);
  };

  var filterOptions = function filterOptions() {
    return props.options.filter(function (option) {
      return option[props.searchParam].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(props.search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
    });
  };

  var filterArrayOptions = function filterArrayOptions() {
    return props.options.filter(function (option) {
      var finded = false;
      props.searchParams.forEach(function (property) {
        if (option[property].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(props.search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""))) {
          // console.log("option selected", property, option[property]);
          finded = true;
        }
      });
      return finded;
    });
  };

  if (Array.isArray(props.options)) {
    if (props.options.length > 0) {
      if (props.search) {
        if (checkParams()) {
          // check is array params
          if (props.searchParams) {
            var filteredOptions = filterArrayOptions(); // console.log("filtered options", filteredOptions);

            if (filteredOptions.length === 0) {
              return props.notFound();
            } else {
              return filteredOptions.map(function (optionFiltered) {
                return props.template(optionFiltered);
              });
            }
          } // check is string param
          else {
              var _filteredOptions = filterOptions();

              if (_filteredOptions.length === 0) {
                return props.notFound();
              } else {
                return _filteredOptions.map(function (optionFiltered) {
                  return props.template(optionFiltered);
                });
              }
            }
        }
      } else {
        return props.options.map(function (option) {
          return props.template(option);
        });
      }
    } else {
      return props.empty();
    }
  }
};

export { ContainerSearch }; // search : lo que se busca
// searchParam : Indicamos sobre qué parametros buscaremos en el objeto
// template : lo que se renderiza por item, se pasa data por parametro
// notFound : Cuando search array es 0
// empty : Cuando array es 0